import { Component } from '@angular/core';

import { NavController, LoadingController } from 'ionic-angular';

import { LoginPage } from '../login/login';
import { ConfirmPage } from '../confirm/confirm';

import { User } from '../../providers/user';

export class UserDetails {
    email: string;
    password: string;
}

export class UserVerify{
    code:string;
    pw:string;
    confirmPw:string;
}

@Component({
  selector: 'page-forgotpw',
  templateUrl: 'forgotpw.html'
})
export class ForgotPwPage {

  public userDetails: UserDetails;
  public userVerify: UserVerify;
  public codeSent:boolean = false;

  error: any;
  public errorMessage:string = "";

  constructor(public navCtrl: NavController,
              public user: User,
              public loadingCtrl: LoadingController) {
    this.userDetails = new UserDetails();
    this.userVerify = new UserVerify();
  }

  resetpw() {

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let details = this.userDetails;
    this.error = null;
    console.log('forgotpw');
    if(details.email){
        this.user.resetPassword(details.email);
        this.codeSent = true;
    }
    loading.dismiss();
  }

  savePw(){
      this.errorMessage ="";

      if(this.userVerify.confirmPw !== this.userVerify.pw){
          this.errorMessage = "Password and confirmation passwords do not match!";
          return;
      }
      else
      {
          this.user.confirmPassword(this.userDetails.email,this.userVerify.code,this.userVerify.pw)
          
          .catch((err)=>{
              this.errorMessage = err.message;
          })
          .then((res)=>{
              if(res){
                this.errorMessage = "";
                alert("Password Changed Sucessfully!");
                this.login();
            }
          });
      }

  }

  login() {
    this.navCtrl.push(LoginPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgotpw/forgotpw.ts